import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleButton({ label = "Continue with Google" }) {
    const onClick = () => {
        const redirectUrl = window.location.origin + "/auth/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
            redirectUrl
        )}`;
    };
    return (
        <button
            type="button"
            onClick={onClick}
            className="w-full flex items-center justify-center gap-3 border border-[#2a2a2a] bg-[#0a0a0a] hover:bg-[#141414] text-white py-3 text-sm uppercase tracking-widest transition-colors"
            data-testid="google-signin-button"
        >
            <GoogleLogo size={18} weight="bold" />
            {label}
        </button>
    );
}
